import { request } from '@/shared/api/request'

export const getReview = (body) => request({ url: `contract/review/${body.type}/page`, method: 'get', params: body.params })